import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import { RouteConfig } from 'vue-router';
import { NAVBAR_TYPE_LIGHT } from '@/util/constants/config';
import { ROUTES } from './routes';

const { PROFILE_CONFIGURATION, PROFILE, } = ROUTES;

const ProfileConfig = () =>
  import(
    /* webpackChunkName: "ProfileConfiguration" */
    '@/views/Profile/Configuration.vue'
  );

const Profile = () =>
  import(
    /* webpackChunkName: "Profile" */
    '@/views/Profile/Profile.vue'
  );

const myProfileRoute: RouteConfig = {
  path: '/',
  component: DashboardLayout,
  children: [
    {
      path: PROFILE_CONFIGURATION.route,
      name: PROFILE_CONFIGURATION.name,
      component: ProfileConfig,
      meta: {
        navbarType: NAVBAR_TYPE_LIGHT,
      },
    },
    {
      path: PROFILE.route,
      name: PROFILE.name,
      component: Profile,
      meta: {
        navbarType: NAVBAR_TYPE_LIGHT,
      },
    }
  ],
};
export default myProfileRoute;
